import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";

//
import ImageUploadApi from "Services/ImageUpload";
import driverApi from "Services/Driver";

//
import { CUSTOM_CONSTANTS } from "Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PreviewDriverDetails = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { openDialog, handleClose, driverId, setCloseAllTabs } = props;

  const [data, setData] = useState([]);
  const [driverDocumentsData, setDriverDocumentsData] = useState([]);
  const [documentsRow, setDocumentsRow] = useState([]);
   const [documentsInitialData, setDocumentsInitialData] = useState([]);
  //

  const handleCloseTabs = () => {
    dispatch(
      showSnackbar({
        message: "Driver Updated Successfully",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      })
    );

    handleClose();
    setCloseAllTabs(true);
  };

  //

  const getDriverCompleteDetails = () => {
    dispatch(showLoader("Loading please wait..."));

    let validation = true;

    if (driverId === "" || driverId === undefined) {
      validation = false;
      dispatch(hideLoader());
    }

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        showSnackbar({
          message: "Driver Details Fetched Successfully",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "success",
        });
        setData(res?.data?.data);
        setDriverDocumentsData(res?.data?.data?.driverDocumentsDetails);
        if(res?.data?.data.driverDocumentsDetails.length == 5){
          setDocumentsInitialData([
            
            {
              id: 1,
              documentId: 0,
              sno: "1",
              documentType: "MOT",
              documentTypeAlias: "MOT",
              file: "",
              status: "No document found",
            },
            {
              id: 2,
              sno: "2",
              documentId: 0,
              documentType: "Vehicle(PHV)",
              documentTypeAlias: "Vehicle(PHV)",
              file: "",
              status: "No document found",
            },
            {
              id: 3,
              sno: "3",
              documentId: 0,
              documentType: "DriversLicence(rear)",
              documentTypeAlias: "DriversLicence(rear)",
              file: "",
              status: "No document found",
            },
            {
              id: 4,
              sno: "4",
              documentId: 0,
              documentType:"Taxi Insurance Policy",
              documentTypeAlias: "Taxi Insurance Policy",
              file: "",
              status: "No document found",
            },
            {
              id: 5,
              sno: "5",
              documentId: 0,
              documentType: "Proof of insurance",
              documentTypeAlias: "PROOF OF INSURANCE",
              file: "",
              status: "No document found",
            },
            {
              id: 6,
              sno: "6",
              documentId: 0,
              documentType: "DriversLicence(front)",
              documentTypeAlias: "DriversLicence(front)",
              file: "",
              status: "No document found",
            },
            {
              id: 7,
              sno: "7",
              documentId: 0,
              documentType: "PCO Licence",
              documentTypeAlias: "PCO Licence",
              file: "",
              status: "No document found",
            },
          ]);
        }
        else{
          setDocumentsInitialData([
            
            
            // {
            //   id: 5,
            //   sno: "5",
            //   documentId: 0,
            //   documentType: "Proof of address",
            //   documentTypeAlias: "PROOF OF ADDRESS",
            //   file: "",
            //   status: "No document found",
            // },
            
            // {
            //   id: 5,
            //   sno: "5",
            //   documentId: 0,
            //   documentType: "Driving License",
            //   documentTypeAlias: "DRIVING LICENSE",
            //   file: "",
            //   status: "No document found",
            // },
            // {
            //   id: 6,
            //   sno: "6",
            //   documentId: 1,
            //   documentType: "Taxi License",
            //   documentTypeAlias: "TAXI LICENSE",
            //   file: "",
            //   status: "No document found",
            // },
            // {
            //   id: 7,
            //   sno: "7",
            //   documentId: 2,
            //   documentType: "Taxi Driver License",
            //   documentTypeAlias: "TAXI DRIVER LICENSE",
            //   file: "",
            //   status: "No document found",
            // },
            // {
            //   id: 8,
            //   sno: "8",
            //   documentId: 3,
            //   documentType: "Insurance Documents",
            //   documentTypeAlias: "INSURANCE DOCUMENTS",
            //   file: "",
            //   status: "No document found",
            // },
              {
              id: 5,
              sno: "5",
              documentId: 0,
              documentType: "MOT",
              documentTypeAlias: "MOT",
              file: "",
              status: "No document found",
            },
            {
              id: 6,
              sno: "6",
              documentId: 1,
              documentType:"Vehicle(PHV)",
              documentTypeAlias: "VEHICLE(PHV)",
              file: "",
              status: "No document found",
            },
            {
              id: 7,
              sno: "7",
              documentId: 2,
              documentType: "DriversLicence(rear)",
              documentTypeAlias: "DriversLicence(rear)",
              file: "",
              status: "No document found",
            },
            {
              id: 8,
              sno: "8",
              documentId: 3,
              documentType: "Taxi Insurance Policy",
              documentTypeAlias: "Taxi Insurance Policy",
              file: "",
              status: "No document found",
            },
            {
              id: 9,
              sno: "9",
              documentId: 4,
              documentType: "DriversLicence(front)",
              documentTypeAlias: "DriversLicence(front)",
              file: "",
              status: "No document found",
            },
            {
              id: 10,
              sno: "10",
              documentId: 5,
              documentType: "PCO Licence",
              documentTypeAlias: "PCO Licence",
              file: "",
              status: "No document found",
            },
          ]);
        } 
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: "Failed to fetch driver details",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    if (validation) {
      driverApi
        .getDriverCompleteDetailsByDId(driverId)
        .then(onSuccess, onFailure);
    }
  };

  useEffect(() => {
    setData([]);
    setDriverDocumentsData([]);
    getDriverCompleteDetails();
  }, [openDialog]);

  useEffect(() => {
    const combinedArray = documentsInitialData.map((item1) => {
      const matchingDocument = driverDocumentsData.find((item2) => {
        return item1.documentTypeAlias === item2?.documentType;
      });

const documentId =matchingDocument && matchingDocument.documentPath !== "" ? "Uploaded" : "Not uploaded";
const documentPath = matchingDocument ? matchingDocument.documentPath  : "-";
const status = matchingDocument ? matchingDocument.documentPath ? matchingDocument.status :"NO DOCUMENT": "NO DOCUMENT";
const uploadedDocumentName = matchingDocument? matchingDocument?.uploadedDocumentName: "-";

      return {
        ...item1,
        documentId,
        file: documentPath,
        status,
        uploadedDocumentName,
      };
    });

    setDocumentsRow(combinedArray);
  }, [driverDocumentsData]);

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"md"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
            <Typography variant="body1" className={classes.title}>
              Confirm Driver Details
            </Typography>
            <IconButton aria-label="close" onClick={handleClose}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <div className={classes.driverContainer}>
              <div className={classes.driverImage}>
                <img
                  src={data?.driverInfoDetails?.image ||"/assets/images/user/avatar.png"}
                  alt="Profile Image"
                  className={classes.profileImage}
                />
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Basic Information</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Username:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.userName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Country Code:</div>
                  {data?.driverInfoDetails?.countryCode}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Mobile Number:</div>
                  {data?.driverInfoDetails?.mobileNumber}
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Email:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.email}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Gender:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.gender}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Country:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.country}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Address:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.address}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Bank Account Number:</div>
                  <div className={classes.value}>
                    {data?.driverInfoDetails?.bankAccountNumber}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Service Details</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Service:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceTypeId?.serviceName}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Service Type:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.serviceKind}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Number:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Model:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleModel}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Driver License Number:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverLicenseNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>License Expiry Date:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.licenseExpiryDate}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Vehicle Insurance Number:</div>

                  <div className={classes.value}>
                    {data?.driverServiceDetails?.vehicleInsuranceNumber}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Insurance Expiry Date:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.insuranceExpiryDate}
                  </div>
                </div>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Driver Documents</h2>
                <table className={classes.table}>
                  <thead className={classes.tableHeader}>
                    <tr>
                      <th className={classes.tableCell}>Document Type</th>
                      <th className={classes.tableCell}>Status</th>
                      <th className={classes.tableCell}>Approval Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentsRow.map((document, index) => (
                      <tr key={index} className={classes.tableRow}>
                        <td className={classes.tableCell}>
                          {document?.documentType}
                        </td>
                        
                        <td className={classes.tableCell}>
                          {document.documentId}
                        </td>
                        <td className={classes.tableCell}>{document.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className={classes.detailsSection}>
                <h2 className={classes.sectionHeader}>Account Status</h2>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Account Status:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.accountStatus === "ONBOARDING"
                      ? "Onboarding"
                      : data?.driverServiceDetails?.accountStatus === "APPROVED"
                      ? "Approved"
                      : data?.driverServiceDetails?.accountStatus === "BANNED"
                      ? "Banned"
                      : ""}
                  </div>
                </div>
                <div className={classes.keyValue}>
                  <div className={classes.key}>Driver Status:</div>
                  <div className={classes.value}>
                    {data?.driverServiceDetails?.driverAccountStatus ===
                    "ACTIVE"
                      ? "Active"
                      : data?.driverServiceDetails?.driverAccountStatus ===
                        "DE_ACTIVE"
                      ? "Deactive"
                      : ""}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            <section className={classes.closeBtn}>
              <Button onClick={handleClose} style={{ marginRight: "10px" }}>
                Back to Edit
              </Button>
            </section>
            <section className={classes.closeBtn}>
              <Button onClick={handleCloseTabs} style={{ marginRight: "10px" }}>
                Confirm & Close
              </Button>
            </section>
          </section>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewDriverDetails;
